import React from 'react';

const Vs = ({ props }) => (
  <div className="event__poster">
    <img className="event__image" src={props.awayTeamLogo} alt="" />
    <span className="event__vs">vs</span>
    <img className="event__image" src={props.homeTeamLogo} alt="" />
  </div>
);

export default Vs;
